export function withHash(value) {
    const raw = String(value == null ? "" : value).trim();

    if (!raw) {
        return "";
    }

    return raw.charAt(0) === "#" ? raw : "#" + raw;
}

export function contrastColor(background) {
    let hex = withHash(background).slice(1);

    if (hex.length === 3) {
        hex = hex
            .split("")
            .map(function (channel) {
                return channel + channel;
            })
            .join("");
    }

    if (!/^[0-9a-f]{6}$/i.test(hex)) {
        return "#000000";
    }

    const r = parseInt(hex.slice(0, 2), 16);
    const g = parseInt(hex.slice(2, 4), 16);
    const b = parseInt(hex.slice(4, 6), 16);
    const yiq = (r * 299 + g * 587 + b * 114) / 1000;

    return yiq >= 128 ? "#000000" : "#ffffff";
}
